var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-25.6 -25.6 563.20 563.20",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.941,170.667H81.569c-5.549,0-11.294,3.24-11.294,8.784v150.588c0,5.544,5.745,11.294,11.294,11.294h351.373 c5.549,0,8.784-5.75,8.784-11.294V179.451C441.726,173.907,438.49,170.667,432.941,170.667z M421.647,321.255H90.353v-130.51 h331.294V321.255z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M432.941,0H81.569C76.02,0,70.275,3.24,70.275,8.784v130.51c0,5.544,4.49,10.039,10.039,10.039 s10.039-4.495,10.039-10.039V20.078h331.294v119.216c0,5.544,4.49,10.039,10.039,10.039s10.039-4.495,10.039-10.039V8.784 C441.726,3.24,438.49,0,432.941,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M431.686,360.157c-5.549,0-10.039,4.495-10.039,10.039v121.725H90.353V370.196c0-5.544-4.49-10.039-10.039-10.039 s-10.039,4.495-10.039,10.039v130.51c0,5.544,5.745,11.294,11.294,11.294h351.373c5.549,0,8.784-5.75,8.784-11.294v-130.51 C441.726,364.652,437.235,360.157,431.686,360.157z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.824,
    y: 100.392,
    width: 90.353,
    height: 20.078
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.824,
    y: 250.98,
    width: 90.353,
    height: 20.078
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.824,
    y: 421.647,
    width: 90.353,
    height: 20.078
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPickup);
export default __webpack_public_path__ + "static/media/icon-pickup.5edea7c682bb199d8638d364601fbba3.svg";
export { ForwardRef as ReactComponent };